// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gjmw","colMin":"styles_colMin__3G-CG"};